const UIHelper = {
	getBannerHeight: () => {
		if (window.innerWidth < 600) {
			return 56;
		}
		return 64;
	},
	setReadOnly: (element, readonly) => {
		if (element) {
			if (readonly) {
				element.setAttribute("disabled", "disabled");
			}
			else {
				element.removeAttribute("disabled");
			}
		}
	}
};

export default UIHelper;
